import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import classnames from 'classnames';
import 'react-select/dist/react-select.css';

import DropdownField from './DropdownField';
import HybridInput from './HybridInput';
import { removeDuplicates } from '../../utility/recentlyUsed';

import './DropdownField.css';
import './TextField.css';

class HybridDropdownTextFieldComponent extends DropdownField {
  constructor(props) {
    super(props);
    this.state.defaultValue = props.value || '';
    this.state.inputText = props.value || '';
  }

  static get propTypes() {
    return {
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      mapFn: PropTypes.func,
      editing: PropTypes.bool,
      possibleValues: PropTypes.array,
      name: PropTypes.string.isRequired,
      filterField: PropTypes.bool,
      onChange: PropTypes.func,
      className: PropTypes.string,
      updateOnClick: PropTypes.bool.isRequired
    };
  }

  static get defaultProps() {
    return {
      mapFn: value => ({ value, label: value }),
      onChange: () => {},
      validationMessage: 'Invalid Dropdown Field',
      updateOnClick: true
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      defaultValue: props.value || '',
      inputText: props.value || ''
    });
  }

  onChange(selectedText) {
    const { updateOnClick } = this.props;
    this.setState({ defaultValue: selectedText, inputText: selectedText }, () => {
      if (updateOnClick) {
        this.onUpdated();
      }
    });
  }

  onFocus() {
    this.setState({
      hasFocus: true
    });
  }

  onBlur() {
    const { inputText } = this.state;
    this.setState({
      defaultValue: inputText,
      hasFocus: false
    }, this.onUpdated);
  }

  onUpdated() {
    const { onChange } = this.props;
    const { defaultValue } = this.state;
    if (this.validate()) {
      onChange(defaultValue);
    }
  }

  showLabel() {
    const { editing } = this.props;
    const { defaultValue, hasFocus } = this.state;
    return !editing || !!defaultValue || hasFocus;
  }

  onInputChange(inputText) {
    this.setState({ inputText });
    return inputText;
  }

  getDropdownOptions() {
    const { mapFn, recentlyUsed = [] } = this.props;
    const { inputText } = this.state;

    let options = inputText ? [mapFn(inputText)] : [];

    if (recentlyUsed) {
      this.addRecentlyUsed(options);
      options = removeDuplicates(options);
    }

    return options;
  }

  addRecentlyUsed(options) {
    const { recentlyUsed, mapFn } = this.props;
    if (recentlyUsed && recentlyUsed.length > 0 && options) {
      const recentlyUsedFormatted = recentlyUsed.map(mapFn);
      options.push(...recentlyUsedFormatted);
    }
    if (options.length > 0) {
      this.prependSeparator(options, 'Recently used');
    }
  }

  renderInput(inputPropsNative) {
    const { editing, name, className, label, required, placeholder } = this.props;
    const placeholderText = placeholder || `${label} ${required ? '' : '(optional)'}`;
    const { defaultValue, inputText } = this.state;

    const inputProps = {
      placeholder: !this.showLabel() ? placeholderText : '',
      name,
      className: classnames(className, 'TextField', 'is-hybrid', `text-${name}`, { 'is-disabled': !editing }),
      value: inputText || '',
      required,
      disabled: !editing
    };

    return (
      <HybridInput inputProps={inputProps} inputPropsNative={inputPropsNative} defaultValue={defaultValue} />
    );
  }

  renderControl() {
    const { editing, name, className,
      required, value } = this.props;
    const options = this.getDropdownOptions();
    const useClass = classnames(className, 'Hybrid', 'DropdownField', `hybrid-dropdown-${name}`, { 'is-disabled': !editing });

    const filterOption = (option, filterString) => {
      const query = filterString.toLowerCase();
      if (!option.value) {
        return true;
      }
      if (option.label.toLowerCase().includes(query)) {
        return true;
      }
      return false;
    };

    if (!editing) {
      return (
        <span className={useClass}>{value || ''}&nbsp;</span>
      );
    }

    return (
      <Select
        name={name}
        className={useClass}
        placeholder={''}
        options={options.length > 0 ? options : undefined}
        clearable={!required}
        onChange={selected => this.onChange(selected)}
        onFocus={() => this.onFocus()}
        onBlur={() => this.onBlur()}
        backspaceRemoves={false}
        noResultsText={false}
        onBlurResetsInput={false}
        onCloseResetsInput={false}
        onSelectResetsInput
        filterOption={filterOption}
        disabled={!editing}
        openOnFocus
        inputRenderer={inputPropsNative => this.renderInput(inputPropsNative)}
        onInputChange={input => this.onInputChange(input)}
        optionRenderer={option => this.renderOption(option)}
        arrowRenderer={() => {}}
        scrollMenuIntoView={false}
        simpleValue
      />
    );
  }
}

export default HybridDropdownTextFieldComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/HybridDropdownTextField.js